import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["icon", "as", "children"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import Icon from 'components/Icon';
import Text from 'components/Text';
import Tab from '.';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var NavBarTab = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var icon = _ref.icon,
    as = _ref.as,
    children = _ref.children,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var Component = as || 'a';
  return /*#__PURE__*/_jsxs(Tab, _objectSpread(_objectSpread({
    stackBelow: "m"
  }, otherProps), {}, {
    as: Component,
    ref: ref,
    children: [icon && /*#__PURE__*/_jsx(Icon, {
      name: icon,
      size: "medium"
    }), /*#__PURE__*/_jsx(Text, {
      align: "center",
      mx: [null, 'xxs'],
      ml: icon ? [null, null, 'xs'] : undefined,
      size: ['xxs', 's', 'm'],
      breakpoints: ['xxs', 'm'],
      children: children
    })]
  }));
});
NavBarTab.displayName = 'NavBarTab';
export default NavBarTab;